import React from 'react';
import TalentJobMatchForm from "./TalentJobMatchForm";
import LoadingBanner from "../../../components/LoadingBanner";
import ErrorBanner from "../../../components/ErrorBanner";
import ResourceNotFound from "../../../components/errors/ResourceNotFound";
import {useAuth} from "../../../providers/AuthProvider";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import {useAPI} from "../../../config/API";

const TalentMatchScoreEditTab = ({
                               opportunity,
                               editable = true,
                               onUpdate = () => true,
                               disabled,
                               getStepActions = false
                           }) => {

    const {
        onRequest,
        opportunity: agencyOpp,
        changeProps
    } = useOpportunity();
    const {auth} = useAuth();
    const {
        data: talentUser,
        isInitialLoading,
        isRefetching,
        refetch,
        error,
    } = useAPI(
        ['fetchSupplierTalentResource', opportunity.user?.id],
        {
            enabled: auth?.canManageClientResourceTalent() && auth?.hasSupplierClientOrg() && !TB.isNaN(parseInt(opportunity.user?.id))
        }
    );

    if (auth && (!auth.canManageClientResourceTalent() || !auth.hasSupplierClientOrg())) {
        return   <div className="flex flex-col pt-8 items-center justify-center">
            <ErrorBanner title="Unauthorized" message="Please try again later"/>
        </div>
    }

    if (isInitialLoading || isRefetching) {
        return (
            <div className="flex flex-col pt-8 items-center justify-center">
                <LoadingBanner message="Loading talent profile"/>
            </div>
        )
    }

    if (error) {
        return (
            <div className="flex flex-col pt-8 items-center justify-center">
                <ErrorBanner title="Something went wrong" message="Please try again later" onRetry={refetch}/>
            </div>
        )
    }
    if (!talentUser) {
        return <ResourceNotFound type="Talent Resource"/>
    }

    return (
        <React.Fragment>
            {getStepActions && getStepActions(
                'Please review the client’s requirements compared to what’s in your talent\'s profile.\n' +
                'If you have experience in missing areas (in gray), you can add them to their profile here.'
            )}


            <TalentJobMatchForm
                minimal={true}
                disabled={disabled}
                onRequest={onRequest}
                job={opportunity.relatedJob()}
                user={talentUser}
            />


        </React.Fragment>
    );
};

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        margin: '0 -15px',
        flexDirection: 'row'
    },
    field: {
        padding: 0,
    },
    rowField: {padding: '0 15px', marginBottom: 0}
};


export default TalentMatchScoreEditTab;